module.exports = __webpack_public_path__ + "img/engine_oil_replace.1aacf5a3.svg";